import { useMemo, useState, type ReactNode } from 'react'
import { PageTrailSlotContext } from './pageTrailSlot'

/**
 * Lets a layout's top bar host the page's breadcrumb trail (see
 * `pageTrailSlot`). Wrap the top bar and the page content in it.
 */
export default function PageTrailSlotProvider({ children }: { children: ReactNode }) {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const value = useMemo(() => ({ element, setElement }), [element])
  return <PageTrailSlotContext.Provider value={value}>{children}</PageTrailSlotContext.Provider>
}

/**
 * Keeps any page header inside it (a dialog) drawing its own trail, rather
 * than the app's top bar.
 */
export function WithoutPageTrailSlot({ children }: { children: ReactNode }) {
  return <PageTrailSlotContext.Provider value={null}>{children}</PageTrailSlotContext.Provider>
}
